import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  sellPrice: {
    color: '#2E7D32',
    fontWeight: 600,
  },
  profitValue: {
    color: '#1976d2',
    fontWeight: 600,
  },
}));
